import { makeStyles, tokens } from "@fluentui/react-components";

export const useWorkspaceSelectorStyles = makeStyles({
  loaderContainer: {
    width: "auto",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    columnGap: "3px",
    width: "100%",
  },
  combobox: {
    flexGrow: 1,
    border: `${tokens.colorNeutralStroke1}`,
  },
  listbox: {
    maxHeight: "300px",
  },
});
